'use strict';

exports.__esModule = true;
exports.transformSeletedLocation = exports.transformDropdownLocation = exports.transformDropdownLanguage = exports.transformDropdownInsurer = exports.transformDropdownSpecialties = exports.transformDropdownKeyword = exports.transformDropdownTreatmentGroups = undefined;

var _doctifyUtils = require('doctify-utils');

var transformDropdownTreatmentGroups = exports.transformDropdownTreatmentGroups = function transformDropdownTreatmentGroups() {
	var treatmentGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	return treatmentGroups.filter(function (treatmentGroup) {
		return treatmentGroup.treatments;
	}).reduce(function (formatedTreatmentGroups, treatmentGroup) {
		return [].concat(formatedTreatmentGroups, [{
			name: treatmentGroup.name,
			isSectionHeader: true
		}], treatmentGroup.treatments);
	}, []);
};

var transformChildrenIcon = function transformChildrenIcon(children) {
	if (!children || !children.length) {
		return null;
	}
	return children.map(function (child) {
		child.iconUri = (0, _doctifyUtils.getResourcePath)(child.icon_uri);
		child.children = transformChildrenIcon(child.children);
		return child;
	});
};

var transformDropdownKeyword = exports.transformDropdownKeyword = function transformDropdownKeyword() {
	var specialties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	return [{
		name: 'Popular Specialties',
		isSectionHeader: true
	}].concat((transformChildrenIcon(specialties) || []).filter(function (specialty) {
		return specialty.sort_order >= 0;
	}), [{
		name: 'Specialties',
		isSectionHeader: true
	}], specialties.filter(function (specialty) {
		return specialty.sort_order < 0;
	}));
};

var transformDropdownSpecialties = exports.transformDropdownSpecialties = function transformDropdownSpecialties() {
	var specialties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	var dropdownItems = [];
	dropdownItems.push({
		name: 'Popular Specialties',
		isSectionHeader: true
	});
	dropdownItems = dropdownItems.concat(specialties.filter(function (specialty) {
		return specialty.sort_order >= 0;
	}));
	dropdownItems.push({
		name: 'Specialties',
		isSectionHeader: true
	});
	dropdownItems = dropdownItems.concat(specialties.filter(function (specialty) {
		return specialty.sort_order < 0;
	}));
	return dropdownItems;
};

var transformDropdownInsurer = exports.transformDropdownInsurer = function transformDropdownInsurer() {
	var insurers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	return insurers;
};

var transformDropdownLanguage = exports.transformDropdownLanguage = function transformDropdownLanguage() {
	var languages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	return languages.filter(function (language) {
		return language.is_visible_from_website;
	});
};

var transformDropdownLocation = exports.transformDropdownLocation = function transformDropdownLocation() {
	var locations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	return locations.map(function (location) {
		return {
			name: location.description,
			placeId: location.place_id
		};
	});
};

var transformSeletedLocation = exports.transformSeletedLocation = function transformSeletedLocation(location) {
	return location ? {
		name: location.formatted_address,
		locationFilterClass: (0, _doctifyUtils.getFilterClass)(location.types),
		value: {
			lng: location.geometry.location.lng(),
			lat: location.geometry.location.lat()
		}
	} : null;
};


// WEBPACK FOOTER //
// ./components/search-page/lib/transformers/dropdowns.js